<script setup lang="ts">
import SuccessMessage from '@/overlays/SuccessMessage.vue';
import { eventBus } from '@/utils/eventBus';
import { onBeforeUnmount, onMounted, ref } from 'vue';

const message = ref<string>();

const handleSuccessMessage = (value: string) => {
  message.value = value;
};

onMounted(() => {
  eventBus.on('success', handleSuccessMessage);
});

onBeforeUnmount(() => {
  eventBus.off('success', handleSuccessMessage);
});
</script>

<template>
  <SuccessMessage
    v-if="message"
    :title="message"
    @close="message = undefined"
  />
</template>
